import PropTypes from 'prop-types';
import React from 'react';

export default function HTMLColumn({ cell }) {
  return <div>{cell.value}</div>;
}

HTMLColumn.propTypes = {
  cell: PropTypes.shape({
    value: PropTypes.any,
  }).isRequired,
};
